<template>
  <ValidationProvider
    v-slot="{ errors }"
    v-bind="validationAttr"
  >
    <BFormGroup
      v-bind="formGroupAttr"
      :label-for="inputID"
    >
      <!-- PASSWORD INPUT WITH PASSWORD TOGGLE -->
      <BInputGroup
        v-if="$attrs?.type === 'password' && !noPasswordToggle"
        :class="{ 'is-invalid': errors.length > 0 }"
      >
        <BFormInput
          :id="inputID"
          v-model="proxyValue"
          v-bind="$attrs"
          :class="inputClass"
          :state="errors.length > 0 ? false : null"
          :type="passwordType"
        />
        <BInputGroupAppend>
          <BButton
            class="pl-2 pr-1 text-dark input-icon"
            variant="success"
            tabindex="-1"
            :disabled="$attrs?.disabled || false"
            @click.prevent="togglePasswordType"
          >
            <i
              v-if="isPasswordVisible"
              class="fad fa-eye h6 mb-0 min-w-40px"
            />
            <i
              v-else
              class="fad fa-eye-slash h6 mb-0 min-w-40px"
            />
          </BButton>
        </BInputGroupAppend>
      </BInputGroup>
      <!-- ANY TYPE OF MASKED INPUT -->
      <BFormInput
        v-else-if="maskable"
        :id="inputID"
        v-model="maskableValue"
        v-mask="currencyMask"
        v-bind="$attrs"
        :class="inputClass"
        :state="errors.length > 0 ? false : null"
      />
      <!-- ANY TYPE OF INPUT -->
      <BFormInput
        v-else
        :id="inputID"
        v-model="proxyValue"
        v-bind="$attrs"
        :class="inputClass"
        :state="errors.length > 0 ? false : null"
      />
      <div
        v-if="(errors.length > 0)"
        class="invalid-feedback"
        v-text="errors[0]"
      />
    </BFormGroup>
  </ValidationProvider>
</template>
<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import MxMisc from '@/mixins/misc'

export default {
  name: 'WVInput',

  mixins: [
    MxMisc
  ],

  inheritAttrs: false,

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    validationAttr: {
      type: Object,
      default: () => ({})
    },
    formGroupAttr: {
      type: Object,
      default: () => ({})
    },
    noPasswordToggle: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: [String, Object, Array],
      default: ''
    },
    maskable: {
      type: Boolean,
      default: false
    }
  },

  emits: ['input'],

  data () {
    return {
      currencyMask: createNumberMask({
        prefix: '',
        allowDecimal: true,
        includeThousandsSeparator: true,
        allowNegative: false,
        integerLimit: 8,
        decimalLimit: 2
      }),
      proxyValue: '',
      maskableValue: '',
      isPasswordVisible: false,
      inputID: `WVID_${String(this.generateId(10)).toUpperCase()}_${this._uid}`
    }
  },

  computed: {
    passwordType () {
      return this.isPasswordVisible ? 'text' : 'password'
    }
  },

  watch: {
    value (val) {
      if (this.maskable) {
        this.maskableValue = val
      } else {
        this.proxyValue = val
      }
    },

    proxyValue (val) {
      this.$emit('input', val)
    },

    maskableValue () {
      this.$emit('input', String(this.maskableValue).replace(/,/g, ''))
    }
  },

  mounted () {
    if (this.maskable) {
      this.maskableValue = this.value
    } else {
      this.proxyValue = this.value
    }
  },

  methods: {
    togglePasswordType () {
      this.isPasswordVisible = !this.isPasswordVisible
    }
  }
}
</script>
